import React, { useState, useEffect } from 'react'

import axios from 'axios'
import { useSelector } from 'react-redux'

import { Tag, Modal, Button, Table, Space, Popconfirm, Input, Select, Typography, Spin, Tooltip } from 'antd'
import {
  LoadingOutlined,
  MailOutlined,
  UserOutlined,
  EditOutlined,
  DeleteOutlined,
  LockOutlined,
  UnlockOutlined,
} from '@ant-design/icons'

import RpcApiClient from 'datasources/RpcApiClient'
import { getEnv } from 'configurations'

import './usersManager.css'

const TYCHO_RPC_API = getEnv('REACT_APP_TYCHO_RPC_API')

const { Option } = Select
const { Text } = Typography

function UsersManager(props) {
  const [isModalUserVisible, setModalUserVisible] = useState(false)
  const [modalState, setModelState] = useState('add')
  const [userSelected, setUserSelected] = useState({})

  const [loadingMaps, setLoadingMaps] = useState(false)
  const [maps, setMaps] = useState([])
  const [loadingUsers, setLoadingUsers] = useState(false)
  const [users, setUsers] = useState([])
  const [loadingCompanies, setLoadingCompanies] = useState(false)
  const [companies, setCompanies] = useState([])
  const [usersTag, setUsersTag] = useState()
  const [usersTable, setUsersTable] = useState([])
  const [search, setSearch] = useState('Search by Email')
  const [searchlbl, setSearchlbl] = useState('')

  const authData = useSelector((state) => state.auth.authData)

  const getMaps = () => {
    setLoadingMaps(false)
    RpcApiClient.getMaps().then((data) => {
      setMaps(data.data.data)
      setLoadingMaps(true)
    })
  }

  const getUsers = () => {
    setLoadingUsers(false)
    RpcApiClient.getUsers().then((data) => {
      setUsers(data.data.data)
      setLoadingUsers(true)
      // console.log(data.data.data)
      var clients = { client: 0, internal: 0, associate: 0, unnasigned: 0 }
      data.data.data.map((obj) => {
        if ('user_tag' in obj) {
          if ('user_tag' in obj)
            obj.user_tag === 'client'
              ? (clients.client += 1)
              : obj.user_tag === 'internal'
              ? (clients.internal += 1)
              : (clients.associate += 1)
        } else {
          clients.unnasigned += 1
        }
      })
      setUsersTag(clients)
    })
  }

  const getCompanies = () => {
    setLoadingCompanies(false)
    RpcApiClient.getCompanies().then((data) => {
      setCompanies(data.data.data)
      setLoadingCompanies(true)
    })
  }

  useEffect(() => {
    getMaps()
    getUsers()
    getCompanies()
  }, [])

  useEffect(() => {
    setUsersTable(
      users.map((user, index) => {
        return { ...user, key: index }
      }),
    )
    //console.log(usersTable)
  }, [users])

  const columns = [
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: 'Company',
      dataIndex: 'user_company',
      key: 'user_company',
      render: (text, record) => (
        <Space size="middle">
          {'user_company' in record === true ? (
            <label key="unnassigned" color="red">
              {record.user_company}
            </label>
          ) : (
            <Tag key="unnassigned" color="red">
              Unnassigned
            </Tag>
          )}
        </Space>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'user_type',
      key: 'user_type',
    },
    {
      title: 'Tag',
      dataIndex: 'user_tag',
      key: 'user_tag',
      render: (text, record) => (
        <Space size="middle">
          {'user_tag' in record === true ? (
            record.user_tag === 'client' ? (
              <Tag color="green">{record.user_tag.charAt(0).toUpperCase() + record.user_tag.slice(1)}</Tag>
            ) : record.user_tag === 'internal' ? (
              <Tag color="blue">{record.user_tag.charAt(0).toUpperCase() + record.user_tag.slice(1)}</Tag>
            ) : (
              <Tag color="purple">{record.user_tag.charAt(0).toUpperCase() + record.user_tag.slice(1)}</Tag>
            )
          ) : (
            <Tag key="unnassigned" color="red">
              Unnassigned
            </Tag>
          )}
        </Space>
      ),
    },
    {
      title: 'Tools',
      dataIndex: 'user_tools',
      key: 'user_tools',
      render: (tools, record) => (
        <Space size="middle">
          {'user_tools' in record === true ? (
            <span>
              {tools.map((tool) => {
                return (
                  <Tag key={tool} color="cyan">
                    {tool.toUpperCase()}
                  </Tag>
                )
              })}
            </span>
          ) : null}
        </Space>
      ),
    },
    {
      title: 'Countries',
      dataIndex: 'countries',
      key: 'countries',
      render: (countries) => (
        <span>
          {countries.map((country) => {
            return <Tag key={country}>{country.toUpperCase()}</Tag>
          })}
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <Tooltip title="Update">
            <EditOutlined
              onClick={() => {
                setUserSelected(record)
                setModelState('update')
                setModalUserVisible(true)
              }}
            />
          </Tooltip>

          {'enabled' in record === false || record.enabled === true ? (
            <Popconfirm
              title="Are you sure to disable this user?"
              onConfirm={() => {
                if ('enabled' in record) {
                  record.enabled = !record.enabled
                } else {
                  record.enabled = false
                }
                let config = {
                  headers: {
                    Authorization: authData.jwtToken,
                    'Content-Type': 'application/json',
                  },
                }
                axios.post(`${TYCHO_RPC_API}rpc/enable_user`, record, config).then((response) => {
                  getUsers()
                  setUserSelected({})
                })
              }}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Disable">
                <LockOutlined />
              </Tooltip>
            </Popconfirm>
          ) : (
            <Popconfirm
              title="Are you sure to enable this user?"
              onConfirm={() => {
                record.enabled = !record.enabled
                let config = {
                  headers: {
                    Authorization: authData.jwtToken,
                    'Content-Type': 'application/json',
                  },
                }
                axios.post(`${TYCHO_RPC_API}rpc/enable_user`, record, config).then((response) => {
                  getUsers()
                  setUserSelected({})
                })
              }}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Enable">
                <UnlockOutlined />
              </Tooltip>
            </Popconfirm>
          )}

          <Popconfirm
            title="Are you sure to delete this user?"
            onConfirm={() => {
              let config = {
                headers: {
                  Authorization: authData.jwtToken,
                  'Content-Type': 'application/json',
                },
              }
              axios.post(`${TYCHO_RPC_API}rpc/delete_user`, record, config).then((response) => {
                getUsers()
                setUserSelected({})
              })
            }}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <DeleteOutlined />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ]

  if (loadingUsers && loadingMaps && loadingCompanies) {
    let usersFormated = users.map((user, index) => {
      return { ...user, key: index }
    })
    let mapsFormated = maps.map((map, index) => {
      return { ...map, key: index }
    })

    const filterList = (filter) => {
      if (filter !== undefined) {
        // console.log(usersTable)
        setSearchlbl(filter.target.value)
        if (search === 'Search by Email') {
          setUsersTable(usersFormated.filter((obj) => obj.email.includes(filter.target.value.toLowerCase())))
        }
        if (search === 'Search by Name') {
          setUsersTable(
            usersFormated.filter((obj) => obj.name.toLowerCase().includes(filter.target.value.toLowerCase())),
          )
        }
      }
    }

    const toggleSearch = (filter) => {
      setSearch(filter)
      setSearchlbl('')
      setUsersTable(usersFormated)
    }

    return (
      <div style={{ height: '100%' }}>
        <Modal
          title="User data"
          visible={isModalUserVisible}
          footer={null}
          onCancel={() => setModalUserVisible(false)}
          destroyOnClose={true}
        >
          <div style={{ height: 'fit-content' }}>
            <div>
              <Text>Email</Text>
              <Input
                value={userSelected.email}
                style={{ marginTop: '5px' }}
                onChange={(e) => setUserSelected({ ...userSelected, email: e.target.value })}
                disabled={modalState === 'update'}
              />
            </div>

            <div style={{ marginTop: '10px' }}>
              <Text>Name</Text>
              <Input
                value={userSelected.name}
                style={{ marginTop: '5px' }}
                onChange={(e) => setUserSelected({ ...userSelected, name: e.target.value })}
              />
            </div>

            <div style={{ marginTop: '10px' }}>
              <Text>Last Name</Text>
              <Input
                value={userSelected.last_name}
                style={{ marginTop: '5px' }}
                onChange={(e) =>
                  setUserSelected({
                    ...userSelected,
                    last_name: e.target.value,
                  })
                }
              />
            </div>

            <div style={{ marginTop: '10px' }}>
              <Text>Company</Text>
              <Select
                allowClear
                style={{ width: '100%' }}
                defaultValue={userSelected.user_company}
                onChange={(e) => setUserSelected({ ...userSelected, user_company: e })}
              >
                {companies.map((comp) => (
                  <Option key={comp.name}> {comp.name}</Option>
                ))}
              </Select>
            </div>

            <div style={{ marginTop: '10px' }}>
              <Text>Type</Text>
              <Select
                allowClear
                style={{ width: '100%' }}
                defaultValue={userSelected.user_type}
                onChange={(e) => setUserSelected({ ...userSelected, user_type: e })}
              >
                <Option key="admin"> admin</Option>
                <Option key="customer"> customer </Option>
              </Select>
            </div>

            <div style={{ marginTop: '10px' }}>
              <Text>Tools</Text>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                defaultValue={userSelected.user_tools}
                onChange={(value) => setUserSelected({ ...userSelected, user_tools: value })}
              >
                <Option key="client" value="layers">
                  Layers
                </Option>
                <Option key="client" value="geocreator">
                  Geocreator
                </Option>
              </Select>
            </div>

            <div style={{ marginTop: '10px' }}>
              <Text>Tag</Text>
              <Select
                allowClear
                style={{ width: '100%' }}
                defaultValue={userSelected.user_tag}
                onChange={(e) => setUserSelected({ ...userSelected, user_tag: e })}
                // onChange={(e) => console.log(e)}
              >
                <Option key="client"> Client</Option>
                <Option key="internal"> Internal </Option>
                <Option key="associate"> Associate </Option>
              </Select>
            </div>

            <div style={{ marginTop: '10px' }}>
              <Text>Countries</Text>
              <Select
                mode="multiple"
                allowClear
                style={{ width: '100%' }}
                defaultValue={userSelected.countries}
                onChange={(value) => setUserSelected({ ...userSelected, countries: value })}
              >
                {mapsFormated.map((map) => (
                  <Option key={map.country}> {map.country}</Option>
                ))}
              </Select>
            </div>

            <Button
              type="primary"
              style={{ marginTop: '10px', width: '100%' }}
              onClick={() => {
                if (modalState === 'add') {
                  let config = {
                    headers: {
                      Authorization: authData.jwtToken,
                      'Content-Type': 'application/json',
                    },
                  }

                  axios.post(`${TYCHO_RPC_API}rpc/create_user`, userSelected, config).then((response) => {
                    getUsers()
                    setUserSelected({})
                    setModalUserVisible(false)
                  })
                } else if (modalState === 'update') {
                  // console.log(userSelected)
                  delete userSelected['key']
                  RpcApiClient.updateUser(userSelected).then(() => {
                    setUserSelected({})
                    setModalUserVisible(false)
                    getUsers()
                  })
                }
              }}
              disabled={
                userSelected === undefined ||
                userSelected.email === undefined ||
                userSelected.last_name === undefined ||
                userSelected.user_company === undefined ||
                userSelected.name === undefined ||
                userSelected.user_type === undefined ||
                userSelected.user_tools === undefined ||
                userSelected.user_tag === undefined
              }
            >
              Save user
            </Button>
          </div>
        </Modal>
        <div style={{ padding: '20px', height: '100%' }}>
          <Button
            type="primary"
            onClick={() => {
              setUserSelected({})
              setModelState('add')
              setModalUserVisible(true)
            }}
          >
            Add User
          </Button>
          <div className="search-user-container">
            {search === 'Search by Email' ? (
              <Input
                style={{ width: '320px' }}
                placeholder={search}
                prefix={<MailOutlined style={{ color: '#d0d0d0' }} />}
                onChange={(e) => filterList(e)}
                value={searchlbl}
              />
            ) : (
              <Input
                style={{ width: '320px' }}
                placeholder={search}
                prefix={<UserOutlined style={{ color: '#d0d0d0' }} />}
                onChange={(e) => filterList(e)}
                value={searchlbl}
              />
            )}
            <Tooltip title="Search by Email">
              <Button
                icon={<MailOutlined />}
                style={{ marginLeft: '15px' }}
                onClick={() => toggleSearch('Search by Email')}
              />
            </Tooltip>
            <Tooltip title="Search by Name">
              <Button
                icon={<UserOutlined />}
                style={{ marginLeft: '15px' }}
                onClick={() => toggleSearch('Search by Name')}
              />
            </Tooltip>
            {/*<div className='user-badges'>
            
            <UserOutlined style={{alignSelf:'center',marginRight:'5px'}}/> 
            <label style={{alignSelf:'center',height:'fit-content',marginRight:'5px'}}>Client:</label>
            <label style={{alignSelf:'center',height:'fit-content',fontWeight:'bold'}}>{usersTag.client}</label>
            </div>
            
            <div className='user-badges'>
            <UserOutlined style={{alignSelf:'center',marginRight:'5px'}}/> 
            <label style={{alignSelf:'center',height:'fit-content',marginRight:'5px'}}>Associate:</label>
            <label style={{alignSelf:'center',height:'fit-content',fontWeight:'bold'}}>{usersTag.associate}</label>
            </div>
            
            <div className='user-badges'>
            <UserOutlined style={{alignSelf:'center',marginRight:'5px'}}/> 
            <label style={{alignSelf:'center',height:'fit-content',marginRight:'5px'}}>Internal:</label>
            <label style={{alignSelf:'center',height:'fit-content',fontWeight:'bold'}}>{usersTag.internal}</label>
            </div>
            
            <div className='user-badges'>
            <UserOutlined style={{alignSelf:'center',marginRight:'5px'}}/> 
            <label style={{alignSelf:'center',height:'fit-content',marginRight:'5px'}}>Unnasigned:</label>
            <label style={{alignSelf:'center',height:'fit-content',fontWeight:'bold'}}>{usersTag.unnasigned}</label>
            </div>*/}
          </div>

          <div style={{ height: 'calc(100% - 104px)', marginTop: '20px' }}>
            <Table columns={columns} dataSource={usersTable} className="table-margins" />
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <Spin style={{ marginTop: '25%' }} tip="Loading..." size="large" indicator={<LoadingOutlined />}>
          <div style={{ height: '100%', width: '100%' }}></div>
        </Spin>
      </div>
    )
  }
}

export default UsersManager
